import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-6 py-20 text-center">
      <XCircle className="w-16 h-16 mx-auto text-zinc-400" strokeWidth={1.5} />
      <h1 className="font-heading font-black text-4xl tracking-tight mt-4" data-testid="payment-cancel-title">Payment canceled</h1>
      <p className="text-zinc-700 mt-3">No charge was made. You can try again from the dashboard anytime.</p>
      <Link to="/dashboard">
        <Button className="mt-8 btn-sharp bg-black hover:bg-zinc-800 text-white text-xs tracking-wider uppercase font-bold py-6 px-8" data-testid="payment-cancel-back-button">
          Back to dashboard
        </Button>
      </Link>
    </div>
  );
}
